import 'swiper/css';
import { initialPageContent } from '../constants/initial-page';
import { CardItem } from '../components/CardItem';
import { Section } from '../components/Section';
import WeatherForecast from '../components/WeatherForecast';

export default function Index() {
  return (
    <Section>
      {initialPageContent?.map((item, index) => (
        <CardItem key={index} item={item} className="col-lg-4" />
      ))}
      <div className="col-12">
        <hr style={{ margin: '1rem 0 3rem', border: '1px solid #ccc' }} />
      </div>
      <WeatherForecast />
    </Section>
  );
}
